import React, { FC, PropsWithChildren } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Details } from '@shared/modules';

import './styles.scss';

export const NotificationRoot: FC<RouteComponentProps> = (
  props: PropsWithChildren<RouteComponentProps>,
) => <Details {...props} headerBar={false} destroyInactiveTabPane />;
